// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

interface TriangleProps {
  className?: string;
}

export function Triangle({ className }: TriangleProps) {
  return (
    <svg
      width="9"
      height="6"
      viewBox="0 0 9 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 5.5L0 5.5L4.5 0.5L9 5.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
